'use strict';

const LOCAL_TZ = 'America/Los_Angeles';

function isDateOnlyOrUtcMidnight(value) {
  const s = String(value || '');
  return /^\d{4}-\d{2}-\d{2}$/.test(s) || /T00:00:00(?:\.000)?Z$/.test(s);
}

function calendarKey(value, { dateOnly = false, tz = LOCAL_TZ } = {}) {
  const s = String(value || '');
  if (dateOnly || isDateOnlyOrUtcMidnight(s)) {
    const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
    return m ? m[1] : '';
  }
  const d = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(d.getTime())) {
    const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
    return m ? m[1] : '';
  }
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(d);
}

function dayNumber(key) {
  const [y, m, d] = String(key).split('-').map(Number);
  if (!y || !m || !d) return null;
  return Date.UTC(y, m - 1, d) / 86400000;
}

function dayWord(n) {
  return `${n} day${n === 1 ? '' : 's'}`;
}

function parseTermsDays(terms) {
  const t = (terms == null || terms === '' ? 'Net 30' : String(terms)).toLowerCase().trim();
  if (t === 'due on receipt' || t === 'due on demand') return 0;
  const net = t.match(/net\s*(\d+)/);
  if (net) return parseInt(net[1], 10);
  const any = t.match(/(\d+)/);
  return any ? parseInt(any[1], 10) : 30;
}

function isHistoryEntered({
  paidAt, submittedAt, dueDate, termsDays, paymentTerms, tz = LOCAL_TZ,
} = {}) {
  if (submittedAt == null || String(submittedAt).trim() === '') return true;
  const paid = calendarKey(paidAt, { dateOnly: isDateOnlyOrUtcMidnight(paidAt), tz });
  const submitted = calendarKey(submittedAt, { tz });
  const a = dayNumber(paid);
  const b = dayNumber(submitted);
  if (a == null || b == null) return true;
  if (a <= b) return true;
  const due = calendarKey(dueDate, { dateOnly: true });
  const d = dayNumber(due);
  const terms = Number.isFinite(Number(termsDays)) ? Number(termsDays) : parseTermsDays(paymentTerms);
  if (d != null && (d - b) > (terms + 3)) return true;
  return false;
}

function paymentTiming({ dueDate, paidAt, tz = LOCAL_TZ } = {}) {
  const due = calendarKey(dueDate, { dateOnly: true });
  const paid = calendarKey(paidAt, { tz });
  const a = dayNumber(due);
  const b = dayNumber(paid);
  if (a == null || b == null) return { kind: 'on_time', days: 0, label: 'Paid on time' };
  const days = b - a;
  if (days < 0) return { kind: 'early', days: -days, label: `Paid ${dayWord(-days)} early` };
  if (days > 0) return { kind: 'late', days, label: `Paid ${dayWord(days)} late` };
  return { kind: 'on_time', days: 0, label: 'Paid on time' };
}

function typicalPayLine({ owner, n, medianDays } = {}) {
  if (!(Number(n) >= 3) || medianDays == null || !Number.isFinite(Number(medianDays))) {
    return 'Not enough history yet';
  }
  const name = String(owner || '').trim() || 'Owner';
  const days = Number(medianDays);
  return `${name} typically pays ${dayWord(days)} after invoice`;
}

export { paymentTiming, typicalPayLine, calendarKey, isHistoryEntered, parseTermsDays, LOCAL_TZ };
